// Dummy test data for systematic form testing

export const testCaregiverData = {
  // Step 1 - Membership
  verificationPath: 'basic' as const,
  
  // Step 2 - Profile  
  firstName: 'Maria',
  lastName: 'Rodriguez',
  email: 'test+caregiver@example.com',
  phone: '(555) 123-4567',
  preferredName: 'Maria',
  bioShort: 'Compassionate caregiver with 8 years of experience helping seniors live independently at home.',
  educationLevel: 'associates' as const,
  languages: ['English', 'Spanish'],
  vaccinationStatus: 'up_to_date' as const,
  vaccinationsCurrent: ['COVID-19', 'Flu'],
  professionalCredentials: ['CNA', 'First Aid'],
  certifications: ['CNA', 'CPR', 'First Aid'],
  
  // Step 3 - Services & Skills
  services: ['Personal care', 'Medication reminders', 'Meal preparation', 'Companionship'],
  skillsDementiaCare: true,
  skillsMobilityAssistance: true,
  skillsMedicationSupport: true,
  hasTransportation: true,
  comfortableWithPets: true,
  willingHousekeeping: true,
  experienceYears: '5 to 9' as const,
  hourlyRate: '$26-30',
  
  // Step 4 - Availability & Area
  caregiverType: 'independent' as const,
  serviceCity: 'Los Angeles',
  serviceState: 'CA',
  serviceZipCode: '90210',
  serviceRadius: 25,
  availabilityDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
  availabilityHours: 'flexible' as const,
  overnight: false,
  startDate: '2025-10-01',
  maxWeeklyHours: '40',
  preferredShift: '4 to 6 hours',
  
  // Step 5 - Agreement
  termsAgreed: true,
  backgroundCheckConsent: true,
};

export const testEarlyAdopterData = {
  email: 'test+early-adopter@example.com',
  firstName: 'Michael',
  lastName: 'Chang',
  role: 'family_member' as const,
  primaryInterest: 'Helping my parents stay safe and independent at home with better monitoring and safety tools.',
  urgencyLevel: 'immediate' as const,
  phone: '(555) 987-6543',
  message: 'My parents have had a few falls recently and I\'m very concerned about their safety. I need better ways to monitor and help them.',
};

export const testProfessionalData = {
  ot: {
    profession: 'ot' as const,
    firstName: 'Jennifer',
    lastName: 'Thompson',
    email: 'test+ot@example.com',
    phone: '(555) 555-0199',
    licenseNumber: 'OT12345',
    licenseState: 'CA',
    specialties: ['home_mods', 'fall_prevention'],
    yearsInPractice: 8,
    serviceRadius: 50,
    website: 'https://www.jentherapy.com',
  },
  caps: {
    profession: 'caps' as const,
    firstName: 'Robert',
    lastName: 'Davis', 
    email: 'test+caps@example.com',
    phone: '(555) 555-0188',
    licenseNumber: 'CAPS67890',
    licenseState: 'TX',
    specialties: ['aging_in_place', 'home_safety'],
    yearsInPractice: 12,
    serviceRadius: 30,
    website: 'https://www.daviscaps.com',
  }
};

export const testSponsorData = {
  firstName: 'Amanda',
  lastName: 'Foster',
  email: 'test+sponsor@example.com', 
  phone: '(555) 555-0177',
  company: 'HealthCare Solutions LLC',
  title: 'VP of Partnerships',
  website: 'https://www.healthcaresolutions.com',
  teamSize: '50-100',
  sponsorshipTier: 'gold',
  message: 'We are interested in sponsoring SeniorThrive to support aging-in-place initiatives in our community.',
  interests: ['Community sponsorship', 'Brand partnership opportunities']
};

export const testContactData = {
  firstName: 'David',
  lastName: 'Wilson',
  email: 'test+contact@example.com',
  phone: '(555) 555-0166',
  subject: 'General Inquiry',
  message: 'I would like to learn more about SeniorThrive services for my elderly mother. She lives alone and we want to ensure her safety at home.',
  topic: 'general'
};